var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "st-Footer" }, [
    _c("div", { staticClass: "st-Footer_Pagetop", on: { click: _vm.goTop } }, [
      _c("i", { staticClass: "el-icon-arrow-up" })
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "st-Footer_Inner" }, [
      _c("nav", { staticClass: "st-FtDirectory" }, [
        _c("div", { staticClass: "st-FtDirectory_Logo" }, [
          _c("a", { attrs: { href: "/" } }, [
            _c("img", {
              attrs: {
                src: require("../../../static/img/landing/logo_white.png"),
                alt: ""
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "st-FtDirectory_Column" }, [
          _c(
            "h3",
            {
              staticClass: "st-FtDirectory_Column-title",
              staticStyle: { width: "200px" }
            },
            [_vm._v("COMPANY"), _c("i")]
          ),
          _vm._v(" "),
          _c("ul", { staticClass: "st-FtDirectory_Column-list" }, [
            _c("li", [
              _c("a", { attrs: { href: "/company" } }, [_vm._v("企業情報")])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "st-FtDirectory_Column" }, [
          _c(
            "h3",
            {
              staticClass: "st-FtDirectory_Column-title",
              staticStyle: { width: "200px" }
            },
            [_vm._v("PRODUCT"), _c("i")]
          ),
          _vm._v(" "),
          _c("ul", { staticClass: "st-FtDirectory_Column-list" }, [
            _c("li", [
              _c("a", { attrs: { href: "/product/product-0001" } }, [
                _vm._v("光学曲線研削加工")
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("a", { attrs: { href: "/product/product-0002" } }, [
                _vm._v("精密ワイヤーカット")
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("a", { attrs: { href: "/product/product-0003" } }, [
                _vm._v("精密平面研削")
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "st-FtDirectory_Column" }, [
          _c(
            "h3",
            {
              staticClass: "st-FtDirectory_Column-title",
              staticStyle: { width: "200px" }
            },
            [_vm._v("INNOVATION"), _c("i")]
          ),
          _vm._v(" "),
          _c("ul", { staticClass: "st-FtDirectory_Column-list" }, [
            _c("li", [
              _c("a", { attrs: { href: "/innovation" } }, [_vm._v("経営革新")])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "st-FtDirectory_Column" }, [
          _c(
            "h3",
            {
              staticClass: "st-FtDirectory_Column-title",
              staticStyle: { width: "200px" }
            },
            [_vm._v("RECRUIT"), _c("i")]
          ),
          _vm._v(" "),
          _c("ul", { staticClass: "st-FtDirectory_Column-list" }, [
            _c("li", [
              _c("a", { attrs: { href: "/recruit" } }, [_vm._v("採用情報")])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "st-FtDirectory_Column" }, [
          _c(
            "h3",
            {
              staticClass: "st-FtDirectory_Column-title",
              staticStyle: { width: "200px" }
            },
            [_vm._v("CONTACT US"), _c("i")]
          ),
          _vm._v(" "),
          _c("ul", { staticClass: "st-FtDirectory_Column-list" }, [
            _c("li", [
              _c("a", { attrs: { href: "/contactus" } }, [
                _vm._v("お問い合わせ")
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "st-FtPress" }, [
        _c(
          "div",
          { staticClass: "st-FtDirectory_Column st-FtPress-contactus" },
          [
            _c("a", { attrs: { href: "javascript:void(0)" } }, [
              _c("img", {
                attrs: {
                  src: require("../../../static/img/landing/address.png")
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "st-FtPress_Logo",
                staticStyle: { "padding-left": "10px" }
              },
              [_vm._v("〒436-0016 掛川市板沢1945番地の11")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "st-FtDirectory_Column st-FtPress-contactus" },
          [
            _c("a", { attrs: { href: "javascript:void(0)" } }, [
              _c("img", {
                attrs: { src: require("../../../static/img/landing/phone.png") }
              })
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "st-FtPress_Logo",
                staticStyle: { "padding-left": "10px" }
              },
              [_vm._v("TEL:(86)573-8205-8763")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "st-FtDirectory_Column st-FtPress-contactus",
            staticStyle: { width: "150px" }
          },
          [
            _c("a", { attrs: { href: "javascript:void(0)" } }, [
              _c("img", {
                attrs: { src: require("../../../static/img/landing/mail.png") }
              })
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "st-FtPress_Logo",
                staticStyle: { "padding-left": "10px" }
              },
              [_vm._v("j0230500@yahoo.co.jp")]
            )
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "st-FtLegal pt-5" }, [
      _c("div", { staticClass: "st-FtLegal_Inner" }, [
        _c("div", { staticClass: "st-FtLegal_Left" }),
        _vm._v(" "),
        _c("div", { staticClass: "st-FtLegal_Right" }, [
          _c("ul", { staticClass: "st-FtLegal_Link" }, [
            _c("li", [
              _c("a", { attrs: { href: "/policy" } }, [
                _vm._v("サイトポリシー")
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("a", { attrs: { href: "/privacy" } }, [
                _vm._v("プライバシーポリシー")
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "st-FtLegal_Copyright pb-5 pb-md-0",
              staticStyle: { "margin-bottom": "0rem" }
            },
            [_c("small", [_vm._v("© 2021 NICECERA")])]
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39f6c75c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39f6c75c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/copyright.vue
// module id = null
// module chunks = 